<template>
    <div>
        <van-nav-bar
                title="银行卡支付"
                left-arrow
                class="my-nav"
                :fixed="true"
                @click-left="$router.back(-1)"
        />

        <div style="margin-top: 50px;">
            <van-cell-group class="user-group">
                <van-field
                        v-model="amountPayable"
                        label="应付金额"
                        placeholder="1288.00元"
                        disabled
                        error
                />
            </van-cell-group>
        </div>
        <div style="margin-top: 10px">
            <van-cell-group class="user-group">
                <van-field
                        v-model="orderNo"
                        label="订单编号"
                        disabled
                />
                <van-field
                        v-model="amount"
                        label="金额"
                        disabled
                />
                <van-field
                        v-model="orderNo"
                        label="订单编号"
                        disabled
                />
                <van-field
                        v-model="amount"
                        label="金额"
                        disabled
                />
                <van-field
                        v-model="orderNo"
                        label="订单编号"
                        disabled
                />
                <van-field
                        v-model="amount"
                        label="金额"
                        disabled
                />
                <van-field
                        v-model="totalAmount"
                        label="合计"
                        disabled
                />
            </van-cell-group>
            <van-cell-group style="margin-top: 10px">
                <van-field
                        v-model="cardAccountName"
                        label="姓名"
                        disabled
                />
                <van-field
                        v-model="cardAccountNumber"
                        label="银行卡号"
                        disabled
                />
                <van-field
                        v-model="verificationCode"
                        center
                        clearable
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                >
                    <van-button slot="button" size="small" type="danger">获取验证码</van-button>
                </van-field>
            </van-cell-group>

        </div>
        <div style="margin-top: 20px">
            <van-button size="large" type="danger" style="margin-top: 0px">确认并同意代扣</van-button>
            <van-cell-group>
                <van-cell title="更多支付方式" is-link icon="other-pay" />
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    import bus from  '../../bus'
    // import {getBankCardInfo} from '../../api/personal_banking'

    export default {
        data() {
            return {
                orders: [],
                orderCodes: bus.state.orderCodes,
                amountPayable:2000.00 + '元',
                orderNo:'2018102211111111',
                amount:1000,
                totalAmount:2000,
                cardAccountName:'',
                cardAccountNumber:'',
                verificationCode:''

            }
        },
        mounted (){
            getBankCardInfo(d => {
                if (d) {
                    this.cardAccountName = d.data.cardAccountName
                    this.cardAccountNumber = d.data.cardAccountNumber
                }
            })

          /*  if(this.orderCodes.length<1){
                this.$router.push('/home')
            }
            this.loadOrder();*/
        },
        methods: {
            loadOrder(){
                this.orders = [];
                this.orderCodes.forEach(code=>orderDetail({code},data=>{
                    this.orders.push(data);
                }))
            }
        }
    }
</script>

<style lang="less" scoped>

</style>